module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagef"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0010-01.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2f1",
    attrs: {
      "id": "fm02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("A FEW WORDS ON THE INGREDIENTS")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Number of people")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each recipe serves four, unless otherwise noted. Christmas dinner parties tend to be large, so you will also find recipes that serve many more. When cooking for fewer guests, you can halve the amounts . . . or eat your meal two days in a row. Simple as that.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Measurements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 tablespoon = 15 ml"), _c('br'), _vm._v("1 coffee spoon = 7 ml"), _c('br'), _vm._v("1 teaspoon = 5 ml")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Oven")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each oven has its own baking characteristics. Some get hotter, others are slower. It could be that your oven takes longer or shorter than the baking times I use in the recipes. These baking times are therefore guidelines. So by all means, rely on your own experience with your own oven and always use an oven thermometer.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Home made broth is always the best choice, so I won’t be repeating this in every recipe. Any dish, no matter how simple, will greatly benefit from the rich and intense flavor of a home-brewed broth. Bouillon cubes or canned or boxed broth make for an easy substitute—of course I understand that not everyone has the time to make their own broth—but they aren’t the most flavorful solution. Therefore I use cubes sparingly and always make sure to freeze my home made broth in small portions. Besides, you can’t beat the smell of a pot of broth gently simmering on the stove. It’s the easiest way to make use of that chicken carcass, along with leftover celeriac, carrots, and leeks from the fridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You can find several broth recipes in the “Basics” section ("), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#page_254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("this page")]), _vm._v(").")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I prefer to use large eggs. Organic farm eggs can vary widely in size. If you are afraid your eggs are too small, simply use two instead of one. Not having enough egg in a recipe can really make a difference.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Milk")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I prefer to use whole milk. The high fat percentage is where the flavor is.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I use flavorful, good-quality olive oil, usually extra virgin, for finishing. I also use it for cooking, because I can taste it in the final dish. I’ve stopped specifying it in my ingredient lists. Unless stated otherwise, “olive oil” means intense, extra-virgin oil of prime quality.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Meat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I used to be much stricter and consistently added “organic” to the meats in my ingredient lists. Today I feel that people should make their own decisions about the meat they buy. Anyway, not everyone shares my ideals and—yes, I know—organic meat is way more expensive. I go by the maxim: Eat less meat, and if you do eat it, buy organic meat from animals that had a decent life. That’s how I do it. Better for the animals and for our planet. In this book I will give you many vegetarian recipes or suggestions for where you can omit the meat.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0011-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 81
// module chunks = 0